<template>
    <div class="popup">
        <div class="popup-content contact">
            <div class="close-button" @click.prevent="closePopup">
                <font-awesome-icon class="font-awesome-icon" :icon="['far', 'times-circle']" size="lg"/>
            </div>
            <h3 class="title">Contact</h3>
            <p>
                <span>Organiq</span>
                <br/>
                <span>+31 (0)10 891 72 90</span>
                <span>info@organiq.nl</span>
                <br/>
                <span>Oostplein 224A-B</span>
                <span>3063 CE Rotterdam</span>
                <span>The Netherlands</span>
            </p>
            <br/>
            <p>
                <span>Building Changes</span>
                <br/>
                <span>+31 (0)15 720 09 01</span>
                <span>info@buildingchanges.nl</span>
                <br/>
                <span>Van Den Burghweg 1</span>
                <span>2628 CS Delft</span>
                <span>The Netherlands</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        closePopup: function() {
            this.$emit('close');
        }
    }
}
</script>